import { useEffect, useMemo, useRef, useState } from "react";
import moment from "jalali-moment";

import { Box, Button, Card, Checkbox, Chip, Collapse, Fade, Grid, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";

import { DESTINATION, LAYOUT_MARGIN, SOURCE } from "Configs/home";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useWindowSize from "Hooks/useWindowSize";
import { IPath } from "Types/path";

// Doesn't look good but it works :(
const SIZES: { [key: string]: number } = {
  operationBoxHeight: 56,
  marginTop: 8,
  toolsBoxHeight: 56,
  marginBottom: 8,
  topContent: 70,
  bottomContent: 56,
  bottomContentMargin: 16,
};

export default function Tickets() {
  const { name } = useAppSelector((state) => state.operation);
  const { visible: visibleInventory } = useAppSelector((state) => state.inventory);
  const { visible: visibleServices } = useAppSelector((state) => state.services);

  const { height } = useWindowSize();

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const toggleCollapse = () => setIsOpen((prev) => !prev);

  const sideRef = useRef<HTMLDivElement>(null);

  const boxHeight = useMemo(() => {
    let result = 0;
    Object.keys(SIZES).forEach((key) => {
      result += SIZES[key];
    });
    return `${height - (result + LAYOUT_MARGIN * 2)}px`;
  }, [height]);

  const data: any = [{ tittle: "بلیط یک" }];

  const renderInventory = () => {
    return (
      <>
        {data?.map((ticket: any) => {
          return (
            <Stack direction="row">
              <Button
                sx={{
                  border: "1px solid #aaa",
                  p: 1,
                  borderRadius: 1,
                  width: "90%",
                  marginBottom: "15px",
                  justifyContent: "flex-start",
                }}
              >
                <Stack sx={{ width: "100%" }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    {ticket.tittle}
                  </Grid>
                </Stack>
              </Button>
              <Checkbox
                inputProps={{ "aria-label": "Checkbox demo" }}
                sx={{
                  "&:hover": { bgcolor: "transparent" },
                }}
              />
            </Stack>
          );
        })}
      </>
    );
  };

  return (
    <Fade in={visibleInventory || visibleServices} mountOnEnter unmountOnExit>
      <Card sx={{ mt: 1, p: 2, width: "100%", boxShadow: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontWeight="800">لیست برنامه حرکت</Typography>

          <Button
            startIcon={<KeyboardDoubleArrowDownIcon sx={{ transform: isOpen ? "rotate(180deg)" : "", transition: "all 0.3s" }} />}
            sx={{ minWidth: "100px" }}
            onClick={toggleCollapse}
          >
            {isOpen ? "بستن" : "بازکردن"}
          </Button>
        </Stack>

        <Collapse in={isOpen}>
          <Box sx={{ height: boxHeight, py: 2, overflowY: "scroll" }} ref={sideRef}>
            {data.length === 0 ? <Typography align="center">مسیری برای نمایش وجود ندارد</Typography> : renderInventory()}
          </Box>
        </Collapse>
      </Card>
    </Fade>
  );
}
